import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { VerifyComponent } from './auth/verify/verify.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RedirectGuard } from './services/redirect-guard.service';
import { TopPageComponent } from './top-page/top-page.component';
import { ScenesComponent } from './scenes/scenes.component';
import { FaqComponent } from './faq/faq.component';
import { LanguageComponent } from './language/language.component';
import { ProductionComponent } from './production/production.component';
import { ContactComponent } from './contact/contact.component';
import { NewsListComponent } from './news-list/news-list.component';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { SpaceDetailsComponent } from './space-details/space-details.component';
import { SpaceDetailsIframeComponent } from './space-details-iframe/space-details-iframe.component';
import { PaymentComponent } from './auth/payment/payment.component';
import { PageDetailsComponent } from './page-details/page-details.component';

import { CardComponent } from './auth/payment/card/card.component';
import { PlanComponent } from './auth/payment/plan/plan.component';
import { ConfirmComponent } from './auth/payment/confirm/confirm.component';

import { WorkflowGuard } from './services/payment/workflow-guard.service';
import { SubscriptionWorkflowGuard } from './services/subscription/subscription-workflow-guard.service';
import { AuthGuardService } from './services/auth-guard.service';
import { SubscriptionComponent } from './auth/subscription/subscription.component';
import { SubscriptionPlanComponent } from './auth/subscription/subscription-plan/subscription-plan.component';
import { SubscriptionConfirmComponent } from './auth/subscription/subscription-confirm/subscription-confirm.component';
import { SubscriptionCardComponent } from './auth/subscription/subscription-card/subscription-card.component';
import { VerifyCollaboratorComponent } from './auth/verify-collaborator/verify-collaborator.component';

const appRoutes: Routes = [
      {
        path: '',
        component: TopPageComponent,
      },
      {
        path: 'scenes',
        component: ScenesComponent,
      },
      {
        path: 'faq',
        component: FaqComponent,
      },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [RedirectGuard]
      },
      {
        path: 'register',
        component: RegisterComponent,
        canActivate: [RedirectGuard]
      },
      {
        path: 'verify/:id',
        component: VerifyComponent,
        canActivate: [RedirectGuard]
      },
      {
        path: 'forgot/password',
        component: ForgotPasswordComponent,
        canActivate: [RedirectGuard]
      },
      {
        path: 'register/collaborator/:id',
        component: VerifyCollaboratorComponent
      },
      {
        path: 'payment',
        component: PaymentComponent,
        canActivate: [AuthGuardService],
        children: [
        { path: '', redirectTo: 'plan', pathMatch: 'full' },
        {
          path: 'plan',
          component: PlanComponent,
          canActivate: [WorkflowGuard]
        },
        {
          path: 'card',
          component: CardComponent,
          canActivate: [WorkflowGuard]
        },
        {
          path: 'confirm',
          component: ConfirmComponent,
          canActivate: [WorkflowGuard]
        }]
      },
      {
        path: 'subscription',
        component: SubscriptionComponent,
        canActivate: [AuthGuardService],
        children: [
        { path: '', redirectTo: 'plan', pathMatch: 'full'},
        {
          path: 'plan',
          component: SubscriptionPlanComponent,
          canActivate: [SubscriptionWorkflowGuard]
        },
        {
          path: 'card',
          component: SubscriptionCardComponent,
          canActivate: [SubscriptionWorkflowGuard]
        },
        {
          path: 'confirm',
          component: SubscriptionConfirmComponent,
          canActivate: [SubscriptionWorkflowGuard]
        }]
      },
      {
        path: 'contact',
        component: ContactComponent
      },
      {
        path: 'page/:slug',
        component: PageDetailsComponent
      },
      {
        path: 'production',
        component: ProductionComponent,
      },
      {
        path: 'news',
        component: NewsListComponent
      },
      {
        path: 'news/:slug',
        component: NewsDetailComponent
      },
      {
        path: 'scenes/iframe/:id',
        component: SpaceDetailsIframeComponent
      },
      {
        path: 'scenes/:id',
        component: SpaceDetailsComponent
      },
      {
        path: '**',
        component: NotFoundComponent
      },
      // Language routes
      { path: ':lang', component: LanguageComponent ,
        children: [{
          path: '', component: TopPageComponent
        },
        {
          path: 'scenes',
          component: ScenesComponent,
        },
        {
          path: 'faq',
          component: FaqComponent,
        },
        {
          path: 'production',
          component: ProductionComponent,
        },
        {
          path: 'login',
          component: LoginComponent,
          canActivate: [RedirectGuard]
        },
        {
          path: 'register',
          component: RegisterComponent,
          canActivate: [RedirectGuard]
        },
        {
          path: 'verify/:id',
          component: VerifyComponent,
          canActivate: [RedirectGuard]
        },
        {
          path: 'forgot/password',
          component: ForgotPasswordComponent,
          canActivate: [RedirectGuard]
        },
        {
          path: '**',
          component: NotFoundComponent
        }]
      },


];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
